import { render, staticRenderFns } from "./custom-header-comp.vue?vue&type=template&id=efb12bf0"
import script from "./custom-header-comp.vue?vue&type=script&lang=js"
export * from "./custom-header-comp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports